import { SIDEBAR_TRANSITION } from '../../Sidebar';
import { mb } from '../../Themes/utilities';
import { rem } from 'polished';
import Item from './Item';
import React from 'react';
import navigationConfig from './navigationConfig';
import styled, { useTheme } from 'styled-components';
const Wrapper = styled.ul `
  display: block;
  list-style-type: none;
  margin: 0;
  height: 100%;
  overflow-y: auto;
  max-height: 100%;
  padding: ${({ theme }) => rem(theme.navigation.verticalPadding)} 0;

  .ReactCollapse--collapse {
    transition: height ${SIDEBAR_TRANSITION};
  }
  .ReactCollapse--content {
    display: flex;
    flex-direction: column;
  }

  width: 100%;
  ${mb('s')} {
    width: ${({ theme }) => rem(theme.navigation.width)};
    min-width: ${({ theme }) => rem(theme.navigation.width)};
  }

  .${navigationConfig.ITEM_LINK_CLASS_NAME} {
    flex-shrink: 0;
    width: 100%;
    padding: ${rem(8)};
    border: none;
    font: inherit;
    background: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: ${rem(16)};
    color: ${({ theme }) => theme.navigation.itemTextColor};
    font-weight: 500;
    text-decoration: none;
    outline: none;
    height: ${({ theme }) => rem(theme.navigation.itemHeight)};
    &.active {
      color: ${({ theme }) => theme.navigation.activeItemTextColor};
      background: ${({ theme }) => theme.navigation.activeItemBackgroundColor};
    }
    &:hover,
    &:active,
    &:focus {
      color: ${({ theme }) => theme.navigation.focusedItemTextColor};
      background: ${({ theme }) => theme.navigation.focusedItemBackgroundColor};
    }
  }
  .${navigationConfig.SUB_ITEM_LINK_CLASS_NAME} {
    flex-shrink: 0;
    width: 100%;
    padding: ${rem(8)} ${rem(8)} ${rem(8)} ${rem(48)};
    border: none;
    font: inherit;
    background: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: ${rem(14)};
    color: ${({ theme }) => theme.navigation.subItemTextColor};
    font-weight: normal;
    text-decoration: none;
    outline: none;
    height: ${({ theme }) => rem(theme.navigation.subItemHeight)};
    &.active {
      color: ${({ theme }) => theme.navigation.activeSubItemTextColor};
      background: ${({ theme }) => theme.navigation.activeSubItemBackgroundColor};
    }
    &:hover,
    &:active,
    &:focus {
      color: ${({ theme }) => theme.navigation.focusedSubItemTextColor};
      background: ${({ theme }) => theme.navigation.focusedSubItemBackgroundColor};
    }
  }
`;
const Items = ({ items, shrunk, renderLink }) => {
    const menuRef = React.useRef(null);
    const theme = useTheme();
    const getPopupPosition = React.useCallback((idx) => {
        if (!menuRef.current) {
            return 0;
        }
        return (theme.navigation.verticalPadding +
            idx * theme.navigation.itemHeight -
            menuRef.current.scrollTop);
    }, [theme]);
    return (React.createElement(Wrapper, { ref: menuRef }, items.map((item, idx) => (React.createElement(Item, { ...item, key: idx, index: idx, shrunk: shrunk, renderLink: renderLink, getPopupPosition: getPopupPosition })))));
};
export default React.memo(Items);
